const MOBILE_MQ = window.matchMedia('(max-width: 1023px)');
const instances = new WeakMap();

function initSection(section) {
  const el = section.querySelector('.s-our-values__swiper');
  if (!el) return;

  if (MOBILE_MQ.matches) {
    if (!instances.has(el)) {
      instances.set(el, new window.Swiper(el, {
        slidesPerView: 1.2,
        spaceBetween: 4,
        grabCursor: true,
        slidesOffsetBefore: 16,
        observer: true,
        observeParents: true,
      }));
    }
  } else {
    if (instances.has(el)) {
      instances.get(el).destroy(true, true);
      instances.delete(el);
    }
  }
}

function initAll() {
  document.querySelectorAll('.s-our-values').forEach(initSection);
}

export function initOurValuesSection() {
  document.addEventListener('DOMContentLoaded', initAll);
  MOBILE_MQ.addEventListener('change', initAll);
  document.addEventListener('shopify:section:load', initAll);
}
